<template>
  <div
    v-if="open"
    class="smart-doc-at-suggest"
    role="listbox"
    :aria-label="ariaLabel"
  >
    <div v-if="loading" class="smart-doc-at-empty">加载中…</div>
    <template v-else-if="items.length">
      <button
        v-for="(item, idx) in items"
        :key="item.key"
        type="button"
        class="smart-doc-at-item"
        :class="{ active: idx === activeIndex }"
        role="option"
        :aria-selected="idx === activeIndex"
        @mousedown.prevent="emit('pick', item)"
        @mouseenter="emit('hover', idx)"
      >
        <span v-if="item.kindLabel" class="smart-doc-at-item-kind">{{ item.kindLabel }}</span>
        <span class="smart-doc-at-item-name">{{ item.name }}</span>
      </button>
    </template>
    <div v-else class="smart-doc-at-empty">{{ emptyText }}</div>
  </div>
</template>

<script setup lang="ts">
export type SmartDocAtMenuItem = {
  key: string;
  kind: 'skill' | 'template' | 'project' | 'project_doc' | 'project_all' | 'category';
  kindLabel: string;
  name: string;
  refId: string;
  /** category 选项：进入下一层 */
  category?: 'skill' | 'template' | 'project';
  /** 项目文档联想：所属项目 */
  projectId?: string;
  projectName?: string;
};

defineProps<{
  open: boolean;
  items: SmartDocAtMenuItem[];
  activeIndex: number;
  loading?: boolean;
  emptyText?: string;
  ariaLabel?: string;
}>();

const emit = defineEmits<{
  pick: [item: SmartDocAtMenuItem];
  hover: [index: number];
}>();
</script>

<style scoped>
/* 输入联想列表（非弹框）：贴输入区上方的轻量建议条 */
.smart-doc-at-suggest {
  position: absolute;
  left: 6px;
  bottom: calc(100% + 4px);
  z-index: 40;
  width: min(280px, calc(100% - 12px));
  max-height: 200px;
  overflow: auto;
  padding: 2px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e5e6eb;
  box-shadow: 0 2px 8px rgba(15, 35, 52, 0.08);
}

.smart-doc-at-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
  color: #1f2329;
  line-height: 1.4;
}

.smart-doc-at-item:hover,
.smart-doc-at-item.active {
  background: #f2f3f5;
  color: #0052d9;
}

.smart-doc-at-item-kind {
  flex-shrink: 0;
  font-size: 11px;
  color: #86909c;
  min-width: 28px;
}

.smart-doc-at-item.active .smart-doc-at-item-kind,
.smart-doc-at-item:hover .smart-doc-at-item-kind {
  color: #266fe8;
}

.smart-doc-at-item-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.smart-doc-at-empty {
  padding: 8px;
  font-size: 12px;
  color: #86909c;
}
</style>
